// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-08-18T14:38:10+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  189285
//    Project:        555
//    Environment:    5341 - master
//    MD5:            411aebe010730c83f7a0570a08d4d193
//    Signature:      eyJpdiI6IlRXVmlGNWJPbnF3MDdGSmd2NkhRc1E9PSIsInZhbHVlIjoiMHpidHlEQmhGSVdiTW42YXVaMEVPMGJYSEZVdXVQM3FhbnMyNVwvbk9KQ0hBaTRxZnJYWmRsTHR3a015akFNdVBiZGRoS1RUa3VRdzdRWXhHTjRRZGVRVTNPSURycWp0WXMxRzNhbjFIZWJkb2lGS3hiTzhBZ24yYlpiM1pIRWpEXC9Rd0xwbWJqcVJqMkhmZTlVRDBDdjBoK1c1a0FVbnM0d1wvTlo3aW91QUFQWFdBZjRXXC9nQzFxcFg0cWhWVW04b0xlXC9HTHExdzJvU1R2N2xCU05tOHJkT1wvYWhvU3FDSWlQMndjTVRBSFRsa0g3UU5aa05nYjBOdjY3SXB2eWwwQVN0a3hiOWk1dFZZRFZHd1poVG44NHltQ1FPRjEwOHMwVTNOTlJ5bE1tSDBlRERWTHd0MnlrWW02ZXZuOStzbWR3TWY3bjY0REo3TmZmeHE3SU02OCs0S3VqR0crbnZsNUczdzFjSmp2U0g3eSt0Z05SNzFMZG53M1M3TVwvZUNETHNORkpVYU9ad1dhaUpuTldGcmpDOUE9PSIsIm1hYyI6IjNhOGQ2Mzk2MjViZjc1YTYyYmMzMjIwY2NjNWUxMTRjNzA2NDJiZmMzMjVhMTg1M2ZiYzA0Mjk1OGQ1MTQxYjIifQ==
document.addEventListener("DOMContentLoaded", () => {
  const icons = document.querySelectorAll(".icon--loyalty");

  if (icons) {
    icons.forEach((icon) => {
        const frames = icon.querySelectorAll(".frame");
        if (frames.length === 0) return;

        const interval = 95;
        const finalHold = 3000;
        const fadeDuration = 500;

        let current = 0;

        function showFrame(index) {
        frames.forEach((frame, i) => {
            frame.style.opacity = i === index ? "1" : "0";
        });
        }

        function animateFrames() {
        showFrame(current);

        const isLast = current === frames.length - 1;
        const delay = isLast ? finalHold : interval;

        setTimeout(() => {
            if (isLast) {
            // Fade out last frame
            frames[current].style.opacity = "0";
            setTimeout(() => {
                current = 0;
                animateFrames();
            }, fadeDuration);
            } else {
            current++;
            animateFrames();
            }
        }, delay);
        }

        animateFrames();
    });
    }
});
